import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../common/GetProxy";
import { handleResponseCode } from "../../../app/utilities/helpers";

const proxy = GetProxy();
const cookies = new Cookies();

// ===================== THUNKS =====================

export const getApprovedOpexDetailsList = createAsyncThunk(
  "post/getApprovedOpexDetailsList",
  async (props) => {
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/budgetManagementController/getApprovedOpexDetailsList/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const data = response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting Opex Details List : ", error);
      throw error;
    }
  },
);

export const getApprovedCapexDetailsList = createAsyncThunk(
  "post/getApprovedCapexDetailsList",
  async (props) => {
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/budgetManagementController/getApprovedCapexDetailsList/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const data = response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting Capex Details List : ", error);
      throw error;
    }
  },
);

export const getBudgetFilters = createAsyncThunk(
  "get/getBudgetFilters",
  async (props) => {
    try {
      const { type } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/budgetManagementController/filters/${type}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        },
      );
      handleResponseCode(response);
      const data = response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting Budget Filters : ", error);
      throw error;
    }
  },
);

export const importBudgetFile = createAsyncThunk(
  "post/importBudgetFile",
  async (props) => {
    try {
      const { formData } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/budgetManagementController/import`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: formData,
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in importing Budget File : ", error);
      throw error;
    }
  },
);

export const updateBudgetId = createAsyncThunk(
  "put/updateBudgetId",
  async (props) => {
    try {
      const { type, id, payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/budgetManagementController/${type}/${id}`,
        {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in updating Budget ID : ", error);
      throw error;
    }
  },
);


export const downloadBudgetTemplate = createAsyncThunk(
  "get/downloadBudgetTemplate",
  async (props) => {
    try {
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/budgetManagementController/templateXLSXForApprovedBudget`,
        {
          method: "GET",
          headers: {
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            USERNAME: User,
            "CMTS-API-TOKEN": Apitoken,
          },
        },
      );
      handleResponseCode(response);
      const data = await response.blob();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in downloading Budget Template : ", error);
      throw error;
    }
  },
);

// ===================== INITIAL STATE =====================

const initialState = {
  capexDetailsList: {},
  capexDetailsLoading: false,
  opexDetailsList: {},
  opexDetailsLoading: false,
  budgetFilters: {},
  budgetFiltersLoading: false,
  error: "",
  apierror: false,
};

// ===================== SLICE =====================

export const BudgetManagementSlice = createSlice({
  name: "budgetManagementSlice",
  initialState,
  reducers: {
    resetBudgetManagementData: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getApprovedCapexDetailsList.pending, (state, action) => {
        state.capexDetailsLoading = true;
        state.capexDetailsList = {};
        state.error = "";
        state.apierror = false;
      })
      .addCase(getApprovedCapexDetailsList.fulfilled, (state, action) => {
        state.capexDetailsLoading = false;
        state.capexDetailsList = action.payload;
        state.apierror = false;
      })
      .addCase(getApprovedCapexDetailsList.rejected, (state, action) => {
        state.capexDetailsLoading = false;
        state.capexDetailsList = {};
        state.error = "something went wrong";
        state.apierror = true;
      })
      .addCase(getApprovedOpexDetailsList.pending, (state, action) => {
        state.opexDetailsLoading = true;
        state.opexDetailsList = {};
        state.error = "";
        state.apierror = false;
      })
      .addCase(getApprovedOpexDetailsList.fulfilled, (state, action) => {
        state.opexDetailsLoading = false;
        state.opexDetailsList = action.payload;
        state.apierror = false;
      })
      .addCase(getApprovedOpexDetailsList.rejected, (state, action) => {
        state.opexDetailsLoading = false;
        state.opexDetailsList = {};
        state.error = "something went wrong";
        state.apierror = true;
      })
      .addCase(getBudgetFilters.pending, (state, action) => {
        state.budgetFiltersLoading = true;
        state.budgetFilters = {};
        state.error = "";
        state.apierror = false;
      })
      .addCase(getBudgetFilters.fulfilled, (state, action) => {
        state.budgetFiltersLoading = false;
        state.budgetFilters = action.payload;
      })
      .addCase(getBudgetFilters.rejected, (state, action) => {
        state.budgetFiltersLoading = false;
        state.budgetFilters = {};
        state.error = "something went wrong";
        state.apierror = true;
      });
  },
});

export const { resetBudgetManagementData } = BudgetManagementSlice.actions;
export default BudgetManagementSlice.reducer;
